<template>
  <div class="card">
    <div class="detail_title">預訂內容</div>
    <div class="detail_container" id="summary">
      <div class="detail_click_count">
        <i class="fas fa-heart" style="color: rgb(255, 238, 0)"></i>
        {{ product.clickCount }}
      </div>
      <div>
        產品編號：<span class="detail_number">{{ product.productCode }}</span>
      </div>
      <div
        class="pre_order_card"
        v-for="(item, idx) in orderList"
        :key="idx"
        v-show="item.price * item.qty > 0 && item.date != placeholder"
      >
        <table class="detail_table">
          <tbody>
            <tr>
              <td colspan="2">票種：{{ item.name }}</td>
            </tr>
            <tr>
              <td>使用日期：</td>
              <td class="right">
                <span class="detail_number">{{ item.date }}</span>
              </td>
            </tr>
            <tr>
              <td>數量：</td>
              <td class="right">
                {{ item.currency
                }}<span class="detail_number">{{ item.price }}</span> x
                <span class="detail_number">{{ item.qty }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="2"><hr /></td>
            </tr>
            <tr>
              <td>合計：</td>
              <td class="right">
                {{ item.currency }}
                <span class="detail_number">{{ item.price * item.qty }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="detail_total_amount">
      總額：HKD
      <span class="detail_number" style="font-size: 22px">{{
        totalAmount
      }}</span>
    </div>
    <div class="detail_btn_group">
      <button
        type="button"
        :disabled="disabled"
        class="btn left"
        @click.stop="addToCart(true)"
      >
        立即購買
      </button>
      <button
        type="button"
        :disabled="disabled"
        class="btn right"
        @click.stop="addToCart(false)"
      >
        加入購物車
      </button>
    </div>
    <div class="detail_tags">
      <div class="detail_tag">
        <template
          v-if="
            product.productCategory.length > 0 &&
            product.productCategory[0] != ''
          "
        >
          <div
            class="detail_bullet"
            v-for="(item, idx) in product.productCategory.slice(0, 3)"
            :key="idx"
            @click.prevent.stop="search('product', item)"
          >
            {{ item }}
          </div>
        </template>
        <template
          v-if="
            product.locationCategory.length > 0 &&
            product.locationCategory[0] != ''
          "
        >
          <div
            class="detail_bullet"
            v-for="(item, idx) in product.locationCategory.slice(0, 3)"
            :key="idx"
            @click.prevent.stop="search('location', item)"
          >
            {{ item }}
          </div>
        </template>
        <template
          v-if="product.otherLabel.length > 0 && product.otherLabel[0] != ''"
        >
          <div
            class="detail_bullet"
            v-for="(item, idx) in product.otherLabel.slice(0, 3)"
            :key="idx"
            @click.prevent.stop="search('other_tag', item)"
          >
            {{ item }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import useEventBus from "@/config/eventBus";

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    orderList: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const disabled = ref(false);
    const eventBus = useEventBus();

    const totalAmount = computed(() => {
      let total = 0;
      props.orderList.forEach(function (item) {
        if (item.date != props.placeholder) {
          total += item.price * item.qty;
        }
      });
      return total;
    });

    const addToCart = (_bool) => {
      disabled.value = true;
      eventBus.emit("addTktProductToCart", _bool);
      setTimeout(() => {
        disabled.value = false;
      }, 300);
    };

    return { totalAmount, disabled, addToCart };
  },
};
</script>